
const React = require('react');
const Link = require('react-router-dom').Link;
const AjaxFunctions = require('../ajaxFunctions');
const Avatar = require('./commonControls.jsx').userAvatar;
const SharedConstants = require('../../../../shared/sharedConstants');
const Redirect = require('react-router-dom').Redirect;
const LeftBarScreen = require('../constants.js').LeftBarScreen;
const ReduxStore = require('./../redux/reduxStore.jsx.js');
import FavoriteButton from './favoriteButton.jsx';
const TextInputModal = require('./textInputModal.jsx').TextInputModal;
const AdditionalCardFunctionsButton = require('./cardFunctions.js');
const EvidenceReview = require('../evidenceReview.jsx').EvidenceCardReview;
const ConjectureReview = require('../conjectureReview.jsx').ConjectureReview;
const ToastAlert = require('./toastAlert');
const getUpdatedPortfolioData = require('../utils').getUpdatedPortfolioData;
const Utils = require('../utils');

import IconButton from "@material-ui/core/IconButton/IconButton";
import Button from "@material-ui/core/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import Toastr from "toastr";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { HoverModal } from './hoverModal.js';
import { UserAvatarV2 } from './commonControls.jsx.js';
import ReactLinkify from 'react-linkify';

let tooltipTitle = (title) => {
   return (
      <React.Fragment>
         <div style={{ fontSize: SharedConstants.TooltipValue.FontSize, lineHeight: SharedConstants.TooltipValue.LineHeight }}>
            {title}
         </div>
      </React.Fragment>
   )
};

class ReviewModal extends React.Component{
   constructor(props) {
      super(props);
   }

   
   render(){
      
      return(
         <Dialog
            fullWidth
            maxWidth={'lg'}
            open={this.props.open}
            onClose={() => this.props.onClose()}
         >
            <DialogContent id={'reviewModal'}>
               {
                  this.props.card.cardType === SharedConstants.CardType.Evidence ?
                     <EvidenceReview
                        currentPortfolio={this.props.currentPortfolio}
                        curCard={this.props.card}
                        closeFunction={() => this.props.onClose()}
                     />
                     :
                     <ConjectureReview
                        currentPortfolio={this.props.currentPortfolio}
                        curCard={this.props.card}
                        closeFunction={() => this.props.onClose()}
                     />
               }
            </DialogContent>
         </Dialog>
      )
   }
}

function UpVoteButton(props){
   return(
         <IconButton className={'btn-top-bar-icon'} onClick={() => props.voteFunction()}>
            <FontAwesomeIcon icon={['fas',"arrow-up"]} size={'1x'} />
         </IconButton>
   )
}

function DownVoteButton(props){
   return(
         <IconButton className={'btn-top-bar-icon'} onClick={() => props.voteFunction()}>
            <FontAwesomeIcon className={'btn-downvote'} icon={['fas',"arrow-down"]} size={'1x'} />
         </IconButton>
   )
}

class BeginReviewButton extends React.Component{
   constructor(props) {
      super(props);
      this.state = {
         showModal: false,
      }
   }

   async onClose(){
      this.setState({showModal:false});
      try {
         let cardsToReview = await AjaxFunctions.getCardsToReview();
         ReduxStore.store.dispatch(ReduxStore.CardFunctions.setToReview(cardsToReview));

         if (window.globals.isSponsor) {
            let unapprovedCards = await AjaxFunctions.getUnapprovedCards();
            ReduxStore.store.dispatch(ReduxStore.CardFunctions.setUnapproved(unapprovedCards));
         }
      }
      catch(err){
         ToastAlert(err);
      }
   }

   render() {
      if(!this.props.showReviewButton) return <div />;
      return (
         <div className='review-card-button'>
               <Button className={'btn-top-bar-icon'} aria-label={`Approve or Reject µPub`} style={{marginTop: '1em'}}
                           onClick={() => this.setState({showModal: true})} variant={'contained'} color={'primary'}>
                  REVIEW
                  <FontAwesomeIcon className={'btn-downvote'} icon={['far', "box-ballot"]} size={'1x'} style={{marginLeft: '1em'}}/>
               </Button>
            <ReviewModal open={this.state.showModal} card={this.props.card} onClose={() => this.onClose() }/>
         </div>
      )
   }
}

function RemoveButton(props){
   if(!props.removeCardFromPortfolio) return (<div />);
   return(
      <div className='card-row-button-container'>
         <i className="fas fa-times text-danger" onClick={() => props.removeCardFromPortfolio(props.card)} />
      </div>
   )
}

function LinkButton(props){
   if(props.cardType !== SharedConstants.CardType.Evidence) return(<div  />);
   if(props.showLinkBtn){
      return(
         <div className='card-row-button-container'>
            <i className="fas fa-link text-info btn-conjecture-link" onClick={() => props.addToCreation()} />
         </div>
      )
   }
   return (<div />);
}

function FavoriteButtonInContainer(props){
   if(props.showFavoriteBtn){
      return(
         <div className='card-row-button-container'>
            <FavoriteButton
               card={props.card}
            />
         </div>
      )
   }
   return(<div />);
}

function UserDiv(props){
   if(props.card.cardType !== SharedConstants.CardType.Synthesis){
      return(
         <div className="post-header-text">
            <div className="post-author">
               <HoverModal
                  linkTo={`/users/profile?idUser=${props.card.creator.id}`}
                  textTitle={`${props.card.creator.firstName} ${props.card.creator.lastName}`}
                  titleStyle={{ fontSize: 16, color: '#007bff', fontWeight: 500 }}
                  avatar={props.card.creator.hasAvatar ? `${window.globals.USER_UPLOADS_BASE_URL}/${props.card.creator.id}/Avatar.png` : null}
                  chipText={`Level ${Utils.calculateUserLevel(props.card.creator.points)} (${props.card.creator.points})`}
                  hoverTitle={`${props.card.creator.firstName} ${props.card.creator.lastName}`}
                  hoverSubtitle={`${props.card.creator.affiliation || ''}`}
                  hoverText={props.card.creator.bio || ''}
                  hoverAnchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                  hoverTransformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
               />
            </div>
            <div className="post-time">{new Date(props.card.creationTime).toLocaleDateString()}</div>

         </div>
      )
   }
   return(<div />);
}

function EditButton(props){
   if (!props.isApproved && props.card.cardType === SharedConstants.CardType.Evidence && props.card.idUser === parseInt(window.globals.idUser)) {
      return(
         <i className="far fa-edit text-info" onClick={() => props.editCard(props.card)} />
      )
   }
   return (<div />);
}

function RowNumber(props){
   if(!props.number) return <div />;
   return(
      <div className={'card-row-number'}>
         {props.number}
      </div>
   )
}

class CardRowBase extends React.Component{
   render() {
      let submitterLink = () => {
         if(this.props.card.idSubmitter && this.props.card.submitterFirstName && this.props.card.submitterLastName){
            return(
               <div className={'submitter-link'}>
                  <Link to={'/users/profile?idUser=' + this.props.card.idSubmitter}>
                     {`${this.props.card.submitterFirstName} ${this.props.card.submitterLastName} `}
                  </Link>
                  Added:
               </div>
            )
         }
      };
      let mainBody = () => {
         if(this.props.cardLink){
            return(
               <Link to={this.props.cardLink} className='dashboard-row-body-content' onClick={this.props.linkFunction}>
                  {this.props.prefixText}
                  {this.props.title}
               </Link>
            )
         }
         return(
            <div>
               {this.props.prefixText}
               {this.props.title}
            </div>
         )
      };
      return(
         <div className={this.props.fullClassName} id={this.props.id}>
            {submitterLink()}
            <div className={"activity-list-item " + this.props.itemClass}>
               <RowNumber number={this.props.rowNumber} />

               <RemoveButton
                  card={this.props.card}
                  removeCardFromPortfolio={this.props.removeCardFromPortfolio}
               />
               <LinkButton
                  showLinkBtn={this.props.showLinkBtn}
                  cardType={this.props.card.cardType}
                  addToCreation={() => this.props.addToCreation(this.props.card)}
               />
               <FavoriteButtonInContainer
                  card={this.props.card}
                  showFavoriteBtn={this.props.showFavoriteBtn}
               />
               <div className='card-row-button-container'>
                  <div>
                     {
                        this.props.upVoteFunction && this.props.card.voteType !== SharedConstants.VoteType.UpVote &&
                        <UpVoteButton voteFunction={() => this.props.upVoteFunction(this.props.card.voteType)} />
                     }
                  </div>
                  <div>
                     {
                        this.props.downVoteFunction && this.props.card.voteType !== SharedConstants.VoteType.DownVote &&
                        <DownVoteButton voteFunction={() => this.props.downVoteFunction(this.props.card.voteType)} />
                     }
                  </div>
               </div>
               <div style={{ marginRight: '1em' }}>
                  <UserAvatarV2 size='small' userData={this.props.card.creator} />
               </div>
               <div className="post-main">
                  <div className="post-header">
                     <UserDiv
                        card={this.props.card}
                     />
                     {
                        this.props.showAdditionalFunctionsButton &&
                        <AdditionalCardFunctionsButton
                           card={this.props.card}
                           portfolios={this.props.portfolios}
                           incubators={this.props.incubators}
                        />
                     }
                  </div>
                  <div className="post-body">
                     <EditButton
                        isApproved={this.props.isApproved}
                        card={this.props.card}
                        editCard={(card) => this.props.editCard(card) }
                     />
                     {mainBody()}
                     <BeginReviewButton
                        showReviewButton={this.props.showReviewButton}
                        card={this.props.card}
                     />
                  </div>
               </div>
            </div>
            {this.props.linkedCards()}
         </div>
      )
   }
}

class EvidenceCardRow extends React.Component{
   render() {
      let cardLink = null;
      if(!this.props.disableCardLink){
         cardLink = this.props.linkBase +
            (this.props.linkBase.includes('?') ? '&' : '?') +
            'cardType=' + SharedConstants.CardType.Evidence +
            '&idCard=' + this.props.card.id +
            '&cModalOpen=1'
      }
      return(
         <CardRowBase
            {...this.props}
            fullClassName={this.props.baseClassName}
            itemClass='evidence-item'
            cardLink={cardLink}
            id={this.props.card.index ? 'e' + this.props.card.index : ''}
            linkedCards={() => {}}
         />
      )
   }
}

class ConjectureCardRow extends React.Component{
   constructor(props) {
      super(props);
      this.state = {
         isExpanded: false,
      }
   }

   render() {
      let linkedCards = () => {};
      if(this.state.isExpanded) {
         linkedCards = () => {
            return (
               <div>
                  <i className="fas fa-chevron-up btn-expanded-toggle"
                     title='Collapse linked evidence information'
                     onClick={() => this.setState({isExpanded: false})}
                  />
                  <CardRow
                     cardType={SharedConstants.CardType.Evidence}
                     card={this.props.card.evidenceCard1}
                     linkFunction={(card) => this.props.linkFunction(card)}
                     showLinkBtn={false}
                     showFavoriteBtn={false}
                     linkBase={this.props.linkBase}
                  />
                  <CardRow
                     cardType={SharedConstants.CardType.Evidence}
                     card={this.props.card.evidenceCard2}
                     linkFunction={(card) => this.props.linkFunction(card)}
                     showLinkBtn={false}
                     showFavoriteBtn={false}
                     linkBase={this.props.linkBase}
                  />
               </div>
            )
         };
      }
      else{
         linkedCards = () => {
            return (
               <div className='conjecture-row-evidence-container activity-list-item evidence-item'>
                  <div style={{display: 'flex'}}>
                        <span title={this.props.card.evidenceCard1.title}>
                        <UserAvatarV2 userData={this.props.card.evidenceCard1.creator}/>
                        </span>
                     <span title={this.props.card.evidenceCard2.title} style={{marginLeft:'10px', marginRight:'10px'}}>
                     <UserAvatarV2 userData={this.props.card.evidenceCard2.creator}/>
                        </span>
                     <i className="fas fa-chevron-down btn-expanded-toggle"
                        title='Show all linked evidence information'
                        onClick={() => this.setState({isExpanded: true})}
                     />
                  </div>
               </div>
            )
         };
      }
      let cardLink = null;
      if(!this.props.disableCardLink){
         cardLink = this.props.linkBase +
            (this.props.linkBase.includes('?') ? '&' : '?') +
            'cardType=' + SharedConstants.CardType.Reasoning +
            '&idCard=' + this.props.card.id +
            '&cModalOpen=1'
      }
      return(
         <CardRowBase
            {...this.props}
            fullClassName={this.props.baseClassName + ' conjecture-group'}
            itemClass='conjecture-item'
            cardLink={cardLink}
            id={this.props.card.index ? 'g' + this.props.card.index : ''}
            linkedCards={linkedCards}
         />
      )
   }
}

class NoteCardRow extends React.Component{
   render() {
      return(
         <CardRowBase
            {...this.props}
            fullClassName={this.props.baseClassName}
            itemClass='note-item'
            cardLink={``}
            id={this.props.card.index ? 'n' + this.props.card.index : ''}
            linkedCards={() => {}}
         />
      )
   }
}

class SynthesisCardRow extends React.Component{
   render() {
      this.props.card.creator = null;
      return(
         <CardRowBase
            {...this.props}
            fullClassName={this.props.baseClassName}
            itemClass='synthesis-item'
            cardLink={''}
            id={this.props.card.index ? 's' + this.props.card.index : ''}
            linkedCards={() => {}}
         />
      )
   }
}

class QuestionCardRow extends React.Component{
   constructor(props) {
      super(props);
      this.state = {
         showAnswerModal: false,
      }
   }

   async modalConfirmFunction(answerText){
      Toastr.options.positionClass = 'toast-bottom-full-width';
      try{
         await AjaxFunctions.submitQuestionAnswer(this.props.card.id, answerText);
         Toastr.success('Answer Submitted.');
         this.props.onQuestionAnswered();
      }
      catch(err){
         Toastr.error(err);
      }
   }

   render() {

      const newWindowDecorator = (href, text, key) => (
         <a href={href} key={key} target="_blank">
             {text}
         </a>
     );

      return(
         <div id={this.props.card.index ? 'q' + this.props.card.index : ''}>
            <div className={"activity-list-item question-item"}>
               <RemoveButton
                  card={this.props.card}
                  removeCardFromPortfolio={this.props.removeCardFromPortfolio}
               />
               <div className='card-row-button-container'>
                  <div>
                     {
                        this.props.upVoteFunction && this.props.card.voteType !== SharedConstants.VoteType.UpVote &&
                        <UpVoteButton voteFunction={() => this.props.upVoteFunction(this.props.card.voteType)} />
                     }
                  </div>
                  <div>
                     {
                        this.props.downVoteFunction && this.props.card.voteType === SharedConstants.VoteType.UpVote &&
                        <DownVoteButton voteFunction={() => this.props.downVoteFunction(this.props.card.voteType)} />
                     }
                  </div>
               </div>
               <div className="post-main mPub-card">
                  <div className="post-header">
                     <div className="post-header-text">
                        <div className="post-time">{new Date(this.props.card.creationTime).toLocaleDateString()}</div>
                     </div>
                  </div>
                  <div className="post-body card-title">
                     <ReactLinkify componentDecorator={newWindowDecorator}>
                        {this.props.title}
                     </ReactLinkify>
                  </div>
                  {this.props.card.answer && <div className={'post-body card-title question-card-answer'}>
                     <ReactLinkify componentDecorator={newWindowDecorator}>
                        {this.props.card.answer}
                     </ReactLinkify>
                  </div>}
                  {
                     this.props.showAnswerButton &&
                     <Button
                        variant="contained"
                        onClick={() => this.setState({showAnswerModal: true})}
                        className={'btnStartAnswer'}
                        color="primary">
                        Answer
                     </Button>
                  }
                  <TextInputModal
                     show={this.state.showAnswerModal}
                     contentText={this.props.title}
                     confirmText={'Submit Answer'}
                     label={'Your Answer'}
                     confirmFunction={(answerText) => this.modalConfirmFunction(answerText)}
                     closeFunction={() => this.setState({showAnswerModal: false})}
                  />
               </div>
            </div>
         </div>
      )
   }
}

export class CardRow extends React.Component{
   constructor(props) {
      super(props);
      this.state = {
         redirectToEvidenceCreation: false,
      }
   }

   editCard(cardData){
      let tagString = '';
      for(let tag of cardData.tags){
         tagString += tag + ' ';
      }

      let toSaveState = {
         source: cardData.source,
         enteredText: cardData.title,
         selectedTopics: cardData.topics,
         tags: tagString,
         citation: cardData.citation,
         sourceDate: cardData.sourceDate,
         tour: null,
         id: cardData.id,
      };

      ReduxStore.store.dispatch(ReduxStore.EvidenceCardFunctions.setRevisingCard(toSaveState));
      this.setState({redirectToEvidenceCreation: true});
   }

   render() {
      if(this.state.redirectToEvidenceCreation){
         return (<Redirect to={'/listView?isRevision=true&leftBarCurScreen=' + LeftBarScreen.CreateCard} />);
      }

      let isApproved = this.props.card.isApproved || this.props.allApproved;

      let prefixText = '';
      if(this.props.card.needsRevision) prefixText = '(Needs Revision) ';
      else if(!isApproved) prefixText = '(In Review) ';

      let title = this.props.card.title;
      if(this.props.titleCharacterLimit){
         title = title.substr(0,this.props.titleCharacterLimit) + ' (click to read more)';
      }

      let baseClassName = '';
      if(!isApproved){
         baseClassName += ' in-review';
      }
      if(this.props.card.needsRevision){
         baseClassName += ' needs-revision';
      }

      let rowProps = {
         card: this.props.card,
         baseClassName,
         upVoteFunction: this.props.upVoteFunction,
         downVoteFunction: this.props.downVoteFunction,
         removeCardFromPortfolio: this.props.removeCardFromPortfolio,
         addToCreation: (card) => this.props.addToCreation(card),
         showFavoriteBtn: this.props.showFavoriteBtn,
         portfolios: this.props.portfolios,
         incubators: this.props.incubators,
         isApproved,
         editCard: (card) => this.editCard(card),
         linkFunction: this.props.linkFunction,
         linkBase: this.props.linkBase,
         prefixText,
         title,
         showAnswerButton: this.props.showAnswerButton,
         onQuestionAnswered: () => this.props.onQuestionAnswered(),
         showLinkBtn: this.props.showLinkBtn,
         rowNumber: this.props.rowNumber,
         showAdditionalFunctionsButton: this.props.showAdditionalFunctionsButton,
         showReviewButton: this.props.showReviewButton,
         disableCardLink: this.props.disableCardLink,
      };

      if(this.props.cardType === SharedConstants.CardType.Evidence){
         return(<EvidenceCardRow {...rowProps}/>);
      }
      else if(this.props.cardType === SharedConstants.CardType.Reasoning){
         return(<ConjectureCardRow {...rowProps}/>);
      }
      else if(this.props.cardType === SharedConstants.CardType.Note){
         return(<NoteCardRow {...rowProps}/>);
      }
      else if(this.props.cardType === SharedConstants.CardType.Synthesis){
         return(<SynthesisCardRow {...rowProps}/>);
      }
      else if(this.props.cardType === SharedConstants.CardType.Question){
         return(<QuestionCardRow {...rowProps}/>);
      }
      return(
         <CardRowBase
            {...rowProps}
         />
      )
   }
}

